import { Currency, VendorBalanceList } from "@/types/common"
import {
  getCurrencyDefaultOfQuickStakes,
  getCurrencyDefaultOfSymbol
} from "@/utils/currency"
import { sleep } from "@common_lib/base/utils/src/tools"

export const useWalletStore = defineStore("wallet", () => {
  const { load, unload, isLoading } = useLoading("WALLET")
  const authStore = useAuthStore()
  const player = computed(() => authStore.playerInfo)

  const isMultiWallet = computed(() => player.value.vendorQuantity > 0)

  const mainWallet = computed(() => ({
    money: player.value.betCredit,
    exposure: player.value.totalExposure,
    vendorQuantity: player.value.vendorQuantity
  }))

  const wallets = ref(new Map())

  const updateWithMultiWallet = (list: VendorBalanceList[]) => {
    list.forEach(vendor => {
      const { vendorSite } = vendor

      wallets.value.set(vendorSite, vendor)
    })
  }

  const currency = ref<Currency & { defaultChip: { amount: number; display: string }[] }>(
    {
      id: 0,
      rate: 1,
      type: "",
      symbol: "",
      minBet: 0,
      defaultChip: []
    }
  )

  const updateCurrency = (current: Currency) => {
    const chip = getCurrencyDefaultOfQuickStakes(current.id)
    const symbol = getCurrencyDefaultOfSymbol(current.id)

    const defaultChip = chip.reduce(
      (arr: { amount: number; display: string }[], node) => {
        const [amount, display] = node
        return [...arr, { amount, display }]
      },
      []
    )

    currency.value = {
      ...current,
      defaultChip,
      symbol: symbol!
    }
  }

  const handlerRefreshMoney = async () => {
    if (isLoading.value) return

    load()
    await sleep(4000)
    unload()
  }

  return {
    mainWallet,
    wallets,
    isMultiWallet,
    currency,
    updateCurrency,
    handlerRefreshMoney,
    updateWithMultiWallet
  }
})

export default useWalletStore
